import { genderOptions, contactTypeOptions, entityTypes } from "@/constants/person.js";
import { mandatePresenceStatuses } from "@/constants/mandate.js";
import { meetingResolutionStatuses } from "@/constants/meeting-resolution.js";
import { meetingStatuses } from "@/constants/meeting.js";
import { voteTypes } from "@/constants/vote.js";
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";

export default {
  data() {
    return {
      /** NOTE: constants used in multiple files */
      genderOptions,
      contactTypeOptions,
      entityTypes,
      mandatePresenceStatuses,
      meetingResolutionStatuses,
      meetingStatuses,
      voteTypes,
    };
  },
  computed: {
    building_owner_id() {
      return localStorage.building_owner_id;
    },
    meeting_guest_id() {
      return localStorage.meeting_guest_id;
    },
    contact_id() {
      return localStorage.contact_id;
    },
    building_id() {
      return localStorage.building_id;
    },
    agencyId() {
      return localStorage.agencyId;
    },
    roles() {
      return localStorage.roles;
    },
    username() {
      return localStorage.username;
    },
  },
  methods: {
    alertError(title = "ERROR", text = "", timer = 1500) {
      return {
        type: "error",
        title: title,
        text: text,
        timer: timer,
        showConfirmButton: false,
      };
    },
    getPersonFullName(person) {
      // gender inculded for individuals
      var name = "";
      if (this.$_.isObject(person)) {
        if (person.entity_type == this.entityTypes.legal) {
          if (person.lastname != null && person.lastname.length > 0) {
            name += person.lastname;
          }
          return name.toUpperCase();
        } else {
          var gender = this.getPersonGender(person);
          if (gender != null && gender.length > 0) {
            name += gender + " ";
          }
          if (person.lastname != null && person.lastname.length > 0) {
            name += person.lastname + " ";
            name = name.toUpperCase();
          }
          if (person.firstname != null && person.firstname.length > 0) {
            name += person.firstname;
          }
          return name;
        }
      } else {
        return "person not defined";
      }
    },
    isVotedStatus(status) {
      if (
        status == this.meetingResolutionStatuses.accepted ||
        status == this.meetingResolutionStatuses.rejected ||
        status == this.meetingResolutionStatuses.sansVote ||
        status == this.meetingResolutionStatuses.notResolved
      ) {
        return true;
      }
    },
    showBr(string) {
      if (string == null) {
        return "";
      }
      return string.replace(/(\r\n|\n|\r)/gm, "<br>");
    },
    goToGoogleMap(address) {
      var str = "https://www.google.com/maps/search/?api=1&query=";
      if (address == null) {
        address = "Paris";
      }
      // address = "Champ de Mars, 5 Avenue Anatole France, 75007 Paris"; // example
      address = encodeURIComponent(address);
      str += address;
      return str;
    },
    getPersonGender(person) {
      try {
        var genderOption = "";
        genderOption = this.$_.findWhere(this.genderOptions, {
          value: person.gender,
        });
        if (genderOption) return genderOption.text;
        else return "";
      } catch {
        return "";
      }
    },
    isParticipationStatus(status) {
      // console.log("status", status);
      if (status == this.mandatePresenceStatuses.physical) {
        return true;
      } else if (status == this.mandatePresenceStatuses.phone) {
        return true;
      } else if (status == this.mandatePresenceStatuses.video) {
        return true;
      } else if (status == this.mandatePresenceStatuses.physical_tab) {
        return true;
      } else {
        return false;
      }
    },
    isPasParticipationStatus(status) {
      if (status == this.mandatePresenceStatuses.not_present) {
        return true;
      } else if (status == this.mandatePresenceStatuses.correspondence) {
        return true;
      } else if (status == this.mandatePresenceStatuses.pouvoir) {
        return true;
      } else {
        return false;
      }
    },
    // NOTE: position steps tunnel texts
    setStepTextsStyles() {
      const stepTexts = document.getElementsByClassName("step-text");
      for (let item of stepTexts) {
        let el = item;

        const textWidth = el.scrollWidth;
        const textHeight = el.scrollHeight;
        const buttonWidth = el.nextElementSibling.scrollWidth;

        let calcMiddle = textWidth / 2 - buttonWidth / 2;

        el.style.top = "-" + textHeight + "px";
        el.style.left = "-" + calcMiddle + "px";
      }
    },
    toLocalTime(timeString) {
      this.$moment.locale("fr");
      let localTime = this.$moment.utc(timeString).toDate();
      localTime = this.$moment(localTime).format("YYYY-MM-DD HH:mm:ss");
      return localTime;
    },
    getPerson(personInfo = {}) {
      try {
        const { personId } = personInfo;
        if (!personId) return {};

        let person = BuildingOwnerORM.find(personId);       

        return person;
      } catch (err) {
        console.error(err);
        return {};
      }
    },
    getPersonName(personInfo, person = undefined) {
      try {
        if (!person) person = this.getPerson(personInfo);

        let name = "";
        if (person.lastname && person.firstname) {
          name = person.lastname + " " + person.firstname;
        } else if (person.lastname) {
          name = person.lastname;
        } else if (person.firstname) {
          name = person.firstname;
        }

        return name.toUpperCase();
      } catch (err) {
        console.error(err);
        return "";
      }
    },
    getPersonNameAndGender(personInfo, person = undefined) {
      try {
        const personGender = this.getPersonGender(personInfo, person);
        const personName = this.getPersonName(personInfo, person);

        let nameAndGender = "";
        if (personGender && personName) {
          nameAndGender = personGender + " " + personName;
        } else if (personName) {
          nameAndGender = personName;
        }

        return nameAndGender;
      } catch (err) {
        console.error(err);
        return "";
      }
    },
  },
};
